export default __webpack_public_path__ + "static/media/new_message.fb3876f4.svg";